/**
 * Vendor Catalog Services
 * Services for vendor catalog management operations
 */
// Export all service classes
export { VendorProductService } from './VendorProductService';
export { VendorProductTypeService } from './VendorProductTypeService';
export { VendorProductStatusService } from './VendorProductStatusService';
export { VendorProductMediaTypeService } from './VendorProductMediaTypeService';
export { VendorProductCategoryService } from './VendorProductCategoryService';
export { VendorProductVariantService } from './VendorProductVariantService';
export { VendorProductMediaService } from './VendorProductMediaService';
export { VendorProductRuleService } from './VendorProductRuleService';
export { VendorProductAnalyticService } from './VendorProductAnalyticService';
export { VendorProductEventLimitService } from './VendorProductEventLimitService';
export { VendorProductLogService } from './VendorProductLogService';
export { VendorCatalogShopService } from './VendorCatalogShopService';
export { VendorProductAddOnService } from './VendorProductAddOnService';
export { VendorProductAddOnCategoryService } from './VendorProductAddOnCategoryService';
export { VendorProductVariantCategoryService } from './VendorProductVariantCategoryService';
export { EventProductStreamingService } from './EventProductStreamingService';
export { StockShopService } from './StockShopService';
export { StockPortalService } from './StockPortalService';
// Import for factory function
import { VendorProductService } from './VendorProductService';
import { VendorProductTypeService } from './VendorProductTypeService';
import { VendorProductStatusService } from './VendorProductStatusService';
import { VendorProductMediaTypeService } from './VendorProductMediaTypeService';
import { VendorProductCategoryService } from './VendorProductCategoryService';
import { VendorProductVariantService } from './VendorProductVariantService';
import { VendorProductMediaService } from './VendorProductMediaService';
import { VendorProductRuleService } from './VendorProductRuleService';
import { VendorProductAnalyticService } from './VendorProductAnalyticService';
import { VendorProductEventLimitService } from './VendorProductEventLimitService';
import { VendorProductLogService } from './VendorProductLogService';
import { VendorCatalogShopService } from './VendorCatalogShopService';
import { VendorProductAddOnService } from './VendorProductAddOnService';
import { VendorProductAddOnCategoryService } from './VendorProductAddOnCategoryService';
import { VendorProductVariantCategoryService } from './VendorProductVariantCategoryService';
import { StockShopService } from './StockShopService';
import { StockPortalService } from './StockPortalService';
/**
 * Create all vendor catalog services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all vendor catalog services
 */
export function createVendorCatalogServices(http, config) {
    return {
        vendorProduct: new VendorProductService(http, config),
        vendorProductType: new VendorProductTypeService(http, config),
        vendorProductStatus: new VendorProductStatusService(http, config),
        vendorProductMediaType: new VendorProductMediaTypeService(http, config),
        vendorProductCategory: new VendorProductCategoryService(http, config),
        vendorProductVariant: new VendorProductVariantService(http, config),
        vendorProductMedia: new VendorProductMediaService(http, config),
        vendorProductRule: new VendorProductRuleService(http, config),
        vendorProductAnalytic: new VendorProductAnalyticService(http, config),
        vendorProductEventLimit: new VendorProductEventLimitService(http, config),
        vendorProductLog: new VendorProductLogService(http, config),
        vendorCatalogShop: new VendorCatalogShopService(http, config),
        vendorProductAddOn: new VendorProductAddOnService(http, config),
        vendorProductAddOnCategory: new VendorProductAddOnCategoryService(http, config),
        vendorProductVariantCategory: new VendorProductVariantCategoryService(http, config),
        stockShop: new StockShopService(http, config),
        stockPortal: new StockPortalService(http, config),
    };
}
//# sourceMappingURL=index.js.map